import React from "react";
import Navbar from "../components/navbar/desktop";
import DesktopFooter from "../components/footer/desktop";
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import PinterestIcon from "@material-ui/icons/Pinterest";
import { graphql } from "gatsby";
import dayjs from "dayjs";
import Seo from "../components/seoHead";

function SinglePost({ data }) {
  let { post } = data.vglwpgraphql;

  return (
    <>
      <Seo data={post?.seo} link={post?.link} featuredImage={post?.featuredImage?.node?.mediaItemUrl} />
      <Navbar />
      <div className="single-blog-container single-blog">
        <main className="main-content">
          <article>
            <header className="entry-main">
              <span className="span-reading-time rt-reading-time">
                <span className="rt-label-prefix">LOOK</span>{" "}
                <span className="rt-time"> 6</span>{" "}
                <span className="rt-label-postfix">MINUTE READ</span>
              </span>
              <h1 className="post-title">{post?.title}</h1>
              <div style={{ position: "relative" }}>
                <div className="featured-image">
                  <img
                    src={post?.featuredImage?.node?.mediaItemUrl}
                    alt=""
                    style={{ width: "100%" }}
                  />
                </div>
                <div className="post-info">
                  <div className="author-avator">
                    <img
                      alt=""
                      src="https://secure.gravatar.com/avatar/5c2747a85444b8b7d2af69029ef17bf8?s=112&amp;d=mm&amp;r=g"
                      data-src="https://secure.gravatar.com/avatar/5c2747a85444b8b7d2af69029ef17bf8?s=112&amp;d=mm&amp;r=g"
                      data-srcset="https://secure.gravatar.com/avatar/5c2747a85444b8b7d2af69029ef17bf8?s=224&amp;d=mm&amp;r=g 2x"
                      height="112"
                      width="112"
                      className="avatar avatar-112 photo lazyloaded"
                      srcSet="https://secure.gravatar.com/avatar/5c2747a85444b8b7d2af69029ef17bf8?s=224&amp;d=mm&amp;r=g 2x"
                    />
                  </div>
                  <div className="author-info">
                    <span className="author-name">
                      by{" "}
                      <span className="author">{post?.author?.node?.name}</span>
                    </span>
                    <span className="post-date">
                      {dayjs(post?.date).format("MMMM DD YYYY")}
                    </span>
                  </div>
                </div>
              </div>
              <div class="social_share">
                <p class="social_share_heading">Share</p>
                <a
                  href={`https://www.facebook.com/sharer/sharer.php?u=https://verygoodlight.com/${post?.uri}`}
                  class="social_share_icon first"
                  target="_blank"
                  rel="noreferrer"
                  title={post?.title}
                >
                  <FacebookIcon />
                </a>
                <a
                  href={`https://twitter.com/share?url=https://verygoodlight.com/${post?.uri}&amp;text=${post?.title}&amp;hashtags=verygoodlight`}
                  class="social_share_icon"
                  title={post?.title}
                >
                  <TwitterIcon />
                </a>
                <a
                  href={`http://pinterest.com/pin/create/button/?url=https://verygoodlight.com/${post?.uri}&media=${post?.featuredImage?.node?.mediaItemUrl}&description=${post?.title}`}
                  class="social_share_icon last"
                  title={post?.title}
                >
                  <PinterestIcon />
                </a>
              </div>
            </header>
            <div className="entry-main">
              <div
                className="entry-content"
                dangerouslySetInnerHTML={{ __html: post?.content }}
              ></div>
            </div>
          </article>
          <DesktopFooter bg={"transparent"} />
        </main>
      </div>
    </>
  );
}

export default SinglePost;

export const pageQuery = graphql`
  query($postUri: ID!) {
    vglwpgraphql {
      post(id: $postUri, idType: SLUG) {
        content
        date
        uri
        title
        featuredImage {
          node {
            mediaItemUrl
          }
        }
        author {
          node {
            name
          }
        }
        seo {
          metaDesc
          metaKeywords
          opengraphAuthor
          opengraphDescription
          opengraphTitle
          opengraphImage {
            mediaItemUrl
          }
          opengraphType
          opengraphUrl
          title
          twitterDescription
          twitterTitle
          twitterImage {
            mediaItemUrl
          }
          canonical
          schema {
            pageType
            raw
            articleType
          }
        }
        link
      }
    }
  }
`;
